// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.detail[data-v-2da3ff82]{\r\n  width: 1200px;\r\n  margin: 0 auto;\n}\n.detail-information[data-v-2da3ff82]{\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin-top: 20px;\n}\n.infor-detail-image[data-v-2da3ff82]{\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1;\r\n          flex: 1;\r\n  margin-left: 20px;\n}\r\n", ""]);
// Exports
module.exports = exports;
